import React from "react";
import "./Breadcrumb.scss";
import { Link } from "gatsby";
import { Location } from "@/interfaces/Location";
import { useDimensions } from "@/hooks/useDimensions";
export type BreadcrumbProps = {
  className?: string;
  location: Location;
  invertColor?: boolean;
  variant?: "article" | "categorie" | "navbar";
  afterRoute?: string;
};
function replacer(value: string) {
  const replaceMap = {
    cdmx: "CDMX",
    edomex: "EDOMEX",
    mexico: "México",
    une: "UNE",
    amis: "AMIS",
    ine: "INE",
    ife: "IFE",
  };
  const keyWords = Object.keys(replaceMap) as (keyof typeof replaceMap)[];
  let key = keyWords[0];
  if (
    keyWords.some((k) => {
      key = k;
      return value.includes(k);
    })
  ) {
    return value.replaceAll(key, replaceMap[key]);
  }
  return value;
}
function capitalizeFirst(value: string) {
  if (!!!value) return value;
  return value.at(0)?.toUpperCase() + value.slice(1);
}

function normalizeTitle(str: string) {
  // Map digits or codes to accented letters
  const replacements: Record<string, string> = {
    a1: "á",
    e1: "é",
    i1: "í",
    o1: "ó",
    u1: "ú",
    n1: "ñ",
    A1: "Á",
    E1: "É",
    I1: "Í",
    O1: "Ó",
    U1: "Ú",
    N1: "Ñ",
  };

  let decoded = decodeURIComponent(str);

  // Replace encodings with actual accents
  Object.entries(replacements).forEach(([key, value]) => {
    decoded = decoded.replace(new RegExp(key, "g"), value);
  });

  // if not decode remove accents
  if (decoded === str) {
    decoded = decoded.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remove accents
  }

  return decoded;
}

export const Breadcrumb = ({
  className,
  location,
  invertColor,
  variant = "article",
  afterRoute,
}: BreadcrumbProps) => {
  const { isMobile } = useDimensions();

  const paths = (() => {
    const result = location.pathname
      .replace("blog/", "")
      .split("/")
      .filter((p) => !!!!p);
    if (!!!!afterRoute) result.push(afterRoute ?? "");
    return result;
  })();
  const pathsLength = paths.length;
  const hasBlog = true; // Always true since Blog is always rendered
  const isBlog = location.pathname.includes("/blog");

  const hasEndViewAll = !!!afterRoute ? false : afterRoute === "Ver todos";

  const handleBack = () => {
    window.history.back();
  };

  return (
    <ul
      className={`momento-breadcrum${invertColor ? " invertColor" : ""}${
        !!!className ? "" : ` ${className}`
      }`}
    >
      <div
        className="arrow-back-icon"
        onClick={handleBack}
        style={
          hasEndViewAll && isMobile
            ? {
                marginLeft: -40,
                marginRight: 10,
              }
            : undefined
        }
      >
        <ArrowBackIcon invertColor={invertColor ?? false} />
      </div>
      {hasBlog && (
        <li>
          <Link to="/" className={`bread-crum-link-${variant}`}>
            Blog
          </Link>
        </li>
      )}
      <li>
        <Link to="/" className={`bread-crum-link-${variant}`}>
          Artículo
        </Link>
      </li>
      {paths.map((p, i) => {
        const title = replacer(capitalizeFirst(p.replaceAll("-", " ")));
        const trimTitle = isMobile
          ? title.length > 12
            ? title.slice(0, 12) + "..."
            : title
          : title;

        return (
          <li key={p}>
            {pathsLength == i + 1 ? (
              <p>{normalizeTitle(trimTitle)}</p>
            ) : (
              <Link to={"#"}>{normalizeTitle(trimTitle)}</Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

const ArrowBackIcon = ({ invertColor }: { invertColor: boolean }) => {
  return (
    <svg
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17L1 9L9 1"
        stroke={!invertColor ? "#A3E9E1" : "#293231"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
